export default __webpack_public_path__ + "static/media/bg_help3.01a6a064.png";